// import { FaRegSun } from "react-icons/fa";
// import { MdPlaylistAdd } from "react-icons/md";

// import UsuarioList from "./Usuario";
// import { UsuarioCreate } from "./Usuario/Components/Create";
// import { UsuarioEdit } from "./Usuario/Components/Edit";
// import { UsuarioPermissionCreate } from "./Usuario/permissoes/create";
// import { EditPermissoes } from "./Usuario/permissoes/edit";
// import { ListPermissoes } from "./Usuario/permissoes/ListPermissoes";

const Module = {
  menuItem: {
    to: "/configuracao",
    title: "Configuração",
    // icon: FaRegSun,
    childrens: [
      // {
      //   to: "/configuracao/cadastro-de-usuarios",
      //   title: "Cadastro de Usuários",
      //   icon: MdPlaylistAdd,
      //   id: 7,
      // },
    ],
  },

  routes: [
    // {
    //   path: "/configuracao/cadastro-de-usuarios",
    //   element: <UsuarioList />,
    //   children: [
    //     { path: ":id", element: <UsuarioEdit /> },
    //     { path: "novo", element: <UsuarioCreate /> },
    //     { path: "listapermissoes/:id", element: <ListPermissoes /> },
    //     {
    //       path: "listapermissoes/:id/:idpermissao",
    //       element: <EditPermissoes />,
    //     },
    //     {
    //       path: "listapermissoes/:id/novo",
    //       element: <UsuarioPermissionCreate />,
    //     },
    //   ],
    // },
  ],
};

export default Module;
